import React, { useState, useEffect, useRef } from "react";
import { Dialog } from "primereact/dialog";

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import QRCode from "qrcode";
import Loader from "../../../../Base/Components/Loader/Loader";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const QRCodeModal = ({selected, setSelected, showEtiqueta, setShowEtiqueta, tipoEtiqueta, setTipoEtiqueta, getInfo}) => {

  const [loading, setLoading] = useState(true);
  const [pdfUrl, setPdfUrl] = useState(null);

  
  const onHideReporte = () => {
    setSelected([])
    setShowEtiqueta(false)
    getInfo()
  };
  
  const obtenerInformacion = (selected) => {
    setLoading(true)
    if (selected.length > 0) {
      if(tipoEtiqueta === 1){
        GenerarReportePDF4x3(selected)
      }else if(tipoEtiqueta === 2){
        GenerarReportePDF6x4(selected)
      }else if(tipoEtiqueta === 3){
        GenerarReportePDF4x1(selected);
      }
    }
    setLoading(false)
  };
  
  const GenerarReportePDF4x3 = (selected) => {
    const contenido = [];

    selected.forEach((lote, index) => {

      const info = {
        T:1,
        Id: lote?.IdLote,
        Code: lote?.NoLoteInt
      }

      let CodigoQR 
      QRCode.toDataURL(JSON.stringify(info), { errorCorrectionLevel: 'Q' }, (err, url) => {
        CodigoQR = url;
      })

      contenido.push({
        table: {
          widths: ["*"],
          body: [
            [
              {
                image: CodigoQR,
                width: 200,
                height: 200,
                margin: [-8, -25, 0, -18],
              },
            ],
            [
              {
                text: `${lote.NoLote || ""}`,
                margin: [10, 5, 15, 5],
                alignment: "center",
                style: "infoGeneral",
              },
            ],
            [
              {
                text: `Proveedor: ${lote?.CustomerName || ''}`,
                margin: [0, 0, 10, 0],
                style: 'infoGeneral2',
              },
            ],
          ],
        },
        layout: {
          defaultBorder: false,
        },
      },index < selected.length - 1 ? { text: '', pageBreak: 'after' } : null);
    })

    const docDefinition = {
      pageSize: {
        width: 216,
        height: 288,
      },
      styles: {
        titulo1: {
          fontSize: 30,
          bold: true,
          alignment: "center",
        },
        infoGeneral: {
          fontSize: 22,
          bold: true,
          alignment: "center",
        },
        infoGeneral2: {
          fontSize: 15,
          bold: false,
          alignment: "center",
        },
      },
      pageMargins: [10, 10, 10, 10],
      content: contenido,
    };

    const doc = pdfMake.createPdf(docDefinition);
    
    doc.getDataUrl((url) => {
      setPdfUrl(url); 
    });
  };

  const GenerarReportePDF6x4 = (selected) => {
    const contenido = [];

    selected.forEach((lote, index) => {

      const info = {
        T:1,
        Id: lote?.IdLote,
        Code: lote?.NoLoteInt
      }

      let CodigoQR 
      QRCode.toDataURL(JSON.stringify(info), { errorCorrectionLevel: 'Q' }, (err, url) => {
        CodigoQR = url;
      })

      contenido.push({
        table: {
          widths: ["*"],
          body: [
            [
              {
                image: CodigoQR,
                width: 275,
                height: 275,
                margin: [-8, -25, 0, -18],
              },
            ],
            [
              {
                text: `${lote.NoLote || ""}`,
                margin: [10, 5, 15, 5],
                alignment: "center",
                style: "infoGeneral",
              },
            ],
            [
              {
                text: `Proveedor: ${lote?.CustomerName || ''}`,
                margin: [0, 0, 10, 0],
                style: 'infoGeneral2',
              },
            ],
          ],
        },
        layout: {
          defaultBorder: false,
        },
      }, index < selected.length - 1 ? { text: '', pageBreak: 'after' } : null);
    })

    const docDefinition = {
      pageSize: {
        width: 288,
        height: 432,
      },
      styles: {
        titulo1: {
          fontSize: 30,
          bold: true,
          alignment: "center",
        },
        infoGeneral: {
          fontSize: 32,
          bold: true,
          alignment: "center",
        },
        infoGeneral2: {
          fontSize: 22,
          bold: false,
          alignment: "center",
        },
      },
      pageMargins: [10, 10, 10, 10],
      content: contenido,
    };

    const doc = pdfMake.createPdf(docDefinition);
    
    doc.getDataUrl((url) => {
      setPdfUrl(url); 
    });
  };

  const GenerarReportePDF4x1 = (selected) => {
    const contenido = [];

    selected.forEach((lote, index) => {

      const info = {
        T:1,
        Id: lote?.IdLote,
        Code: lote?.NoLoteInt
      }

      let CodigoQR 
      QRCode.toDataURL(JSON.stringify(info), { errorCorrectionLevel: 'Q' }, (err, url) => {
        CodigoQR = url;
      })

      contenido.push({
        columns: [
          {
            margin: [-5, -4, 0, 0],
            table: {
              widths: ["*"],
              body: [
                [
                  {
                    image: CodigoQR,
                    width: 75,
                    height: 75,
                  },
                ],
              ],
            },
            layout: {
              defaultBorder: false,
            },
          },
          {
            margin: [-50, 15, 5, 0],
            table: {
              widths: ["*"],
              body: [
                [
                  {
                    text: `${lote?.NoLote}`,
                    style: "titulo1",
                    alignment: "center",
                  },
                ],
                [
                  {
                    text: `Proveedor: ${lote?.CustomerName.substring(0, 70) || ""}`,
                    style: "infoGeneral",
                  },
                ],
              ],
            },
            layout: "noBorders",
          },
        ],
      },index < selected.length - 1 ? { text: '', pageBreak: 'after' } : null);
    })

    const docDefinition = {
      pageSize: {
        width: 288,
        height: 72,
      },
      styles: {
        titulo1: {
          fontSize: 15,
          bold: true,
          alignment: "center",
        },
        infoGeneral: {
          fontSize: 12,
          bold: true,
          alignment: "center",
        },
      },
      pageMargins: [10, 0, 10, 10],
      content: contenido,
    };

    const doc = pdfMake.createPdf(docDefinition);
    
    doc.getDataUrl((url) => {
      setPdfUrl(url); 
    });
  };


  useEffect(() => {
    if (showEtiqueta) {
      obtenerInformacion(selected);
    }
  }, [showEtiqueta]);

  return (
    <Dialog
      visible={showEtiqueta}
      onHide={onHideReporte}
      style={{ width: "63vw", height: "85vh" }}
    >
      <Loader loading={loading} querySelector={"#Modal"} />
      <div id="Modal">
        {!loading && pdfUrl && (
          <iframe
            src={pdfUrl}
            style={{ width: "60vw", height: "75vh", border: "1px solid #ccc" }}
            id="foo"
            title="Reporte QR PDF"
          />
        )}
      </div>
      
    </Dialog>
  );
};

export default QRCodeModal;
